import './App.css';
import PersonalInfo from './PersonalInfo';
import AboutMe from './AboutMe';
import Experience from './Experience';

function App() {
  return (
    <div className="App">
      <PersonalInfo />
      <AboutMe />
      <Experience />
    </div>
  );
}

export default App;
